import api from './api';

export const getOutreachStatus = () => api.get('/outreach/status');
export const toggleOutreachEngine = (enabled) => api.post('/outreach/toggle', { enabled });
export const updateOutreachConfig = (config) => api.put('/outreach/config', config);
export const getOutreachLogs = (limit = 50) => api.get('/outreach/logs', { params: { limit } });
export const getOutreachQueue = () => api.get('/outreach/queue');
export const sendOutreachNow = (leadId) => api.post(`/outreach/send-now/${leadId}`);

// Custom Commands
export const getCommands = () => api.get('/outreach/commands');
export const createCommand = (data) => api.post('/outreach/commands', data);
export const updateCommand = (id, data) => api.put(`/outreach/commands/${id}`, data);
export const toggleCommand = (id, enabled) => api.put(`/outreach/commands/${id}/toggle`, { enabled });
export const deleteCommand = (id) => api.delete(`/outreach/commands/${id}`);

// Outreach AI Identity (own configurable agent personality — isolated from Support AI)
export const getOutreachIdentity = () => api.get('/outreach/identity');
export const updateOutreachIdentity = (patch) => api.put('/outreach/identity', patch);
export const resetOutreachIdentity = () => api.post('/outreach/identity/reset');

